import { DARK_COLOR_ARR, LIGHT_COLOR_ARR } from "./constant"
import { ChartOption, LineChartProps } from "./interface"
import '../chart.scss'
import '../barChartLess.less'

export const makeupOptions = (props: LineChartProps, chartType: string) => {
  const {
    formatterFunc,
    isDark,
    legendData,
    colorArr,
    series,
    xAxisData,
    setOtherConfigFunc,
    isShowLegend = true,
    isShowTooltip = true,
    barMaxWidth = 80,
    isMultipleCompetitor = false,
    splitNum = 24,
    yAxisFormat,
  } = props;

  let preIndex = 0
  const intervalFunc = (index: number) => {
    const count = xAxisData?.length;
    const defaultInterval = parseInt(((count - 1) / splitNum).toString());
    let differNum = count - defaultInterval * splitNum - 1;
    if (index === count - 1) {
      // 遍历完数据重置（防止数据被刷掉）
      differNum = count - defaultInterval * splitNum - 1;
      preIndex = 0
      return true
    }
    if (index === 0) {
      return true
    }
    // 间隔数
    let currentInterval = differNum > 0 ? defaultInterval : defaultInterval - 1
    if (preIndex + 1 + currentInterval === index) {
      differNum = differNum > 0 ? differNum - 1 : 0
      preIndex = index;
      return true
    }
    return false
  }

  const opts = {
    textStyle: {
      fontFamily: "Roboto Regular,-apple-system,PingFang SC,microsoft yahei ui,microsoft yahei,sans-serif"
    },
    tooltip: {
      show: isShowTooltip,
      trigger: 'axis',
      backgroundColor: 'rgba(0,0,0,0)',
      // backgroundColor: 'rgba(255, 255, 255, 0.75)',
      borderWidth: 0,
      borderRadius: 6,
      textStyle: {
        color: '#FFFFFF',
        fontSize: 12,
      },
      axisPointer: {
        type: chartType === 'line' ? 'line' : 'shadow',
      },
      confine: true,
      hideDelay: 200,
      triggerOn: 'mousemove',
      padding: 0,
      formatter: formatterFunc ? formatterFunc : null
    },
    grid: {
      x: 10,
      y: 20,
      x2: 10,
      y2: 30,
      containLabel: true
    },
    legend: isMultipleCompetitor ? legendData :
      {
        show: isShowLegend,
        type: 'scroll',
        data: legendData,
        selectedMode: true,
        orient: 'horizontal',
        itemHeight: 8,
        itemWidth: 8,
        icon: 'circle',
        bottom: -6,
        itemGap: 18,
        pageIconColor: '#444444', //翻页下一页的三角按钮颜色
        pageIconInactiveColor: '#888888', //翻页（即翻页到头时）
        pageIconSize: 12, //翻页按钮大小
        pageButtonPosition: 'end',//start
        left: 'center',
        textStyle: { //图例文字的样式
          color: '#888888',
          fontSize: 12,
          lineHeight: 16,
        }
      },
    color: colorArr ? colorArr : isDark ? DARK_COLOR_ARR : LIGHT_COLOR_ARR,
    xAxis: [{
      type: 'category',
      data: xAxisData,
      interval: 1,
      axisLabel: {
        color: '#888888',
        fontSize: 12,
        align: 'center',
        interval: !isMultipleCompetitor ? 'auto' : (index) => intervalFunc(index),
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
        interval: !isMultipleCompetitor ? 'auto' : (index) => intervalFunc(index),
      },
      axisLine: {
        show: true
      },
      axisPointer: {
        type: chartType === 'line' ? 'line' : 'shadow',
      },
    }],
    axisLabel: {
      showMinLabel: true, // 强制显示最小值
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#ddd',
        },
      },
      axisLabel: {
        formatter: (value: number) => {
          if (yAxisFormat instanceof Function) {
            return yAxisFormat(value)
          }
          return value;
        },
        color: '#888888',
        fontSize: 12,
      },
    },
    series,
    barMaxWidth,
  } as ChartOption;
  return setOtherConfigFunc ? setOtherConfigFunc(opts) : opts;

}

